import React from 'react';
import { FormMultiSelect } from '@getro/rombo';
import { Formik, Form, Field } from 'formik';
import PropTypes from 'prop-types';

import { FormikAutoSubmit } from '../../../../../atoms/formikAutoSubmit';
import { useReachabilityFilter } from './useReachabilityFilter';

export const ReachabilityFilter = ({ value, setFilters }) => {
  const { formSchema, onSubmit, reachabilityOptions } = useReachabilityFilter({ setFilters });

  return (
    <Formik
      initialValues={{ reachability: value || [] }}
      validationSchema={formSchema}
      onSubmit={onSubmit}
      enableReinitialize
    >
      <Form>
        <FormikAutoSubmit />
        <Field
          name="reachability"
          label="Reachability"
          placeholder="Select"
          size="small"
          component={FormMultiSelect}
          options={reachabilityOptions}
          isSearchable={false}
          anchorToBody
        />
      </Form>
    </Formik>
  );
};

ReachabilityFilter.propTypes = {
  value: PropTypes.array,
  setFilters: PropTypes.func.isRequired,
};

ReachabilityFilter.defaultProps = {
  value: [],
};
